<!-- <section class="first-sec">
    <h2 class="head" [style.color]="bookingPage.headColor">Contact Us</h2>
    <div>
        <div class="box">

            <div class="gold-live-main">
                <div class="d-flex">
                    <p class="labelhead" [style.color]="bookingPage.labelheadColor"><i
                            class="fa-solid fa-phone my-phone"></i> &nbsp;&nbsp;Booking Number : </p>
                    <p class="gold-live" [style.color]="bookingPage.goldliveColor">
                        <a href="tel:9160006702" class="footer-sub-heading" target="_blank">
                            {{bookingPage.BookingNumber}}</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="box">

            <div class="gold-live-main">
                <div class="d-flex">
                    <p class="labelhead" [style.color]="bookingPage.labelheadColor"> <i
                            class="fa-regular fa-envelope"></i>
                        &nbsp;&nbsp;Account Create : </p>
                    <p class="gold-live" [style.color]="bookingPage.goldliveColor"><a
                            href="https://mail.google.com/mail/u/0/?fs=1&amp;tf=cm&amp;to=info@goldbharat.com"
                            target="_blank">{{bookingPage.AccountCreate}}</a></p>
                </div>
            </div>
        </div>
        <div class="box">

            <div class="gold-live-main">
                <div class="d-flex">
                    <p class="labelhead" [style.color]="bookingPage.labelheadColor"> <i
                            class="fa-brands fa-whatsapp"></i>&nbsp;&nbsp;WhatsApp Number : </p>
                    <p class="gold-live" [style.color]="bookingPage.goldliveColor"><a href="https://wa.me//9160006702"
                            class="footer-sub-heading" target="_blank">{{ bookingPage.BookingNumber }}</a></p>
                </div>
            </div>
        </div>
        <div class="box">

            <div class="gold-live-main">
                <div class="d-flex">
                    <p class="labelhead" [style.color]="bookingPage.labelheadColor"><i
                            class="fa-solid fa-headset"></i>&nbsp;&nbsp;Technical Support : </p>
                    <p class="gold-live" [style.color]="bookingPage.goldliveColor"><a
                            href="https://mail.google.com/mail/u/0/?fs=1&amp;tf=cm&amp;to=info@goldbharat.com"
                            target="_blank">{{bookingPage.TechnicalSupport}}</a></p>
                </div>
            </div>
        </div>
        <div class="box">

            <div class="gold-live-main">
                <div class="d-flex">
                    <p class="labelhead" [style.color]="bookingPage.labelheadColor"><i
                            class="fa-solid fa-location-dot"></i>&nbsp;&nbsp; Address : </p>
                    <p class="gold-live gold-live-add" [style.color]="bookingPage.goldliveColor">{{bookingPage.Address}}
                    </p>
                </div>
                <div>
                    <iframe [src]="url" height="100%" class="mymap-image" allowfullscreen=""
                        loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="first-sec">
  <h2 class="head">Contact Us</h2>

  <div class="contact-cards">

    <div class="box" style="animation-delay: 0.05s;">
      <div class="gold-live-main">
        <div class="d-flex">
          <div class="icon-circle">
            <i class="fa-solid fa-phone"></i>
          </div>
          <div class="text-wrap">
            <p class="labelhead">Booking Number</p>
            <p class="gold-live">
              <a href="tel:9160006702" target="_blank">{{bookingPage.BookingNumber}}</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="box" style="animation-delay: 0.15s;">
      <div class="gold-live-main">
        <div class="d-flex">
          <div class="icon-circle">
            <i class="fa-regular fa-envelope"></i>
          </div>
          <div class="text-wrap">
            <p class="labelhead">Account Create</p>
            <p class="gold-live">
              <a href="https://mail.google.com/mail/u/0/?fs=1&amp;tf=cm&amp;to=info@goldbharat.com"
                target="_blank">{{bookingPage.AccountCreate}}</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="box" style="animation-delay: 0.25s;">
      <div class="gold-live-main">
        <div class="d-flex">
          <div class="icon-circle">
            <i class="fa-brands fa-whatsapp"></i>
          </div>
          <div class="text-wrap">
            <p class="labelhead">WhatsApp Number</p>
            <p class="gold-live">
              <a href="https://wa.me//9160006702" target="_blank">{{ bookingPage.BookingNumber }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="box" style="animation-delay: 0.35s;">
      <div class="gold-live-main">
        <div class="d-flex">
          <div class="icon-circle">
            <i class="fa-solid fa-headset"></i>
          </div>
          <div class="text-wrap">
            <p class="labelhead">Technical Support</p>
            <p class="gold-live">
              <a href="https://mail.google.com/mail/u/0/?fs=1&amp;tf=cm&amp;to=info@goldbharat.com"
                target="_blank">{{bookingPage.BookingNumber}}</a>
            </p>
           <a href="https://mail.google.com/mail/u/0/?fs=1&amp;tf=cm&amp;to=info@goldbharat.com"
                target="_blank" style="color: #12142b;font-size: 16px;">{{bookingPage.AccountCreate}}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="box box-address" style="animation-delay: 0.45s;">
      <div class="gold-live-main">
        <div class="d-flex">
          <div class="icon-circle">
            <i class="fa-solid fa-location-dot"></i>
          </div>
          <div class="text-wrap">
            <p class="labelhead">Address</p>
            <p class="gold-live gold-live-add">{{bookingPage.Address}}</p>
          </div>
        </div>
        <div class="map-wrap">
          <iframe [src]="url" height="100%" class="mymap-image" allowfullscreen=""
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>

  </div>
</section>